import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Table } from '@model/reservation';
import { BatchSynchRequestUpdated, Section, SettingsDataRequest, SettingsDataResponse, TablesPlanUpdateResponse, WorkingDate } from '@model/tables-plan';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TablesPlanApiService {

  constructor(private httpClient: HttpClient, private translate: TranslateService, private store: Store<{}>) { }

  private baseUrl = `${environment.apiUrl}`;

  getTablesPlan(restaurantId: number | string, date: Date): Observable<{ workingDate: WorkingDate, sections: Section[], tables: Table[] }> {
    restaurantId = `${restaurantId}`;
    const workingDate = moment(date).format('yyyy-MM-DD');

    return this.httpClient.post<{ workingDate: WorkingDate, sections: Section[], tables: Table[] }>(`${this.baseUrl}/workingDate/specificDate`, { restaurantId, workingDate }).pipe(
      map((res: { workingDate: WorkingDate, sections: Section[], tables: Table[] }) => {
        return res;
      })
    );
  }

  update(updated: BatchSynchRequestUpdated): Observable<TablesPlanUpdateResponse> {
    return this.httpClient.post<TablesPlanUpdateResponse>(`${this.baseUrl}/workingDate/update`, JSON.stringify(updated)).pipe(
      map((res: TablesPlanUpdateResponse) => {
        return res;
      })
    );
  }

  getRestaurantSettings(restaurantId: number | string): Observable<SettingsDataResponse> {
    return this.httpClient.post<SettingsDataResponse>(`${this.baseUrl}/settings/retrieve/restaurantSettings`, { restaurantId }).pipe(
      map((res: SettingsDataResponse) => {
        return res;
      })
    );
  }

  updateRestaurantSettings(restaurantId: number | string, restaurantSettings: SettingsDataRequest): Observable<TablesPlanUpdateResponse> {
    return this.httpClient.post<TablesPlanUpdateResponse>(`${this.baseUrl}/settings/update/restaurantSettings`, { restaurantId, restaurantSettings }).pipe(
      map((res: TablesPlanUpdateResponse) => {
        return res;
      })
    );
  }
}
